import validator from "validator";

/**
 * Validates an email using `validator.js`, ensuring it follows RFC 5322 standards.
 * @param email - The email string to validate.
 * @returns `true` if the email is valid, `false` otherwise.
 */
export function isValidEmail(email: string): boolean {
  return validator.isEmail(email);
}
